export const globalParams = {};

export default newOptions => {
  return Object.assign(globalParams, newOptions);
};
